import { useContext, useEffect, useState } from 'react'

import type { Filter, NeedsBasedFilter } from '../../../../generated/frontend'
import type { AppliedFilterItem } from '../../../../shared/types/ReviewsFilters'
import { ReviewsTemplateContext } from '../ReviewsTemplateContext'
import { getSelectedFilters } from '../utils/get-selected-filters'

export const useAppliedFilters = (
  basicFilters?: Filter[],
  needsBasedFilters?: NeedsBasedFilter[]
) => {
  const [appliedFilters, setAppliedFilters] = useState<AppliedFilterItem[] | undefined>([])
  const {
    state: {
      filterContext: { basicFilterData, selectedNeedsBasedFilters, needsBasedFilterData },
    },
  } = useContext(ReviewsTemplateContext)

  useEffect(() => {
    setAppliedFilters(
      getSelectedFilters({
        basicFilters,
        basicFilterData,
        selectedNeedsBasedFilters,
        needsBasedFilters,
        needsBasedFilterData,
      })
    )
  }, [
    basicFilterData,
    basicFilters,
    needsBasedFilterData,
    needsBasedFilters,
    selectedNeedsBasedFilters,
  ])

  return {
    appliedFilters,
    filterCount: appliedFilters?.length || 0,
  }
}
